import { FlowStepData } from "../FlowStepData";

export class SaveFlowData extends FlowStepData {
    readonly __type: string = "save_flow_data";

    constructor() {
        super();
        this.name = "Save Flow Data";
    }
}
